import { gql } from "@grandvisionhq/graphql";
const productMediaFragment = gql`
  fragment ReturnProductMediaFragment on Media {
    images {
      label
      url
    }
  }
`;
const productFragment = gql`
  fragment ReturnProductFragment on Variant {
    sku
    displayName
    media {
      ...ReturnProductMediaFragment
    }
    ... on SolutionVariant {
      gan
    }
    ... on ContactLensVariant {
      gan
    }
  }
  ${productMediaFragment}
`;
export {
  productFragment,
  productMediaFragment
};
//# sourceMappingURL=product.js.map
